import React from 'react'

interface IconProps {
  className?: string
}

const MessageNotificationSquare = ({ className }: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M 11 4 L 7.8 4 C 6.12 4 5.28 4 4.638 4.327 C 4.074 4.615 3.615 5.074 3.327 5.638 C 3 6.28 3 7.12 3 8.8 L 3 14 C 3 14.93 3 15.395 3.102 15.777 C 3.38 16.812 4.188 17.62 5.224 17.898 C 5.605 18 6.07 18 7 18 L 7 20.336 C 7 20.868 7 21.135 7.109 21.272 C 7.204 21.391 7.348 21.46 7.501 21.46 C 7.676 21.46 7.884 21.293 8.3 20.96 L 10.685 19.052 C 11.173 18.662 11.416 18.467 11.688 18.329 C 11.928 18.206 12.184 18.116 12.449 18.061 C 12.748 18 13.06 18 13.684 18 L 15.2 18 C 16.88 18 17.72 18 18.362 17.673 C 18.927 17.385 19.385 16.927 19.673 16.362 C 20 15.72 20 14.88 20 13.2 L 20 13"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="18" cy="6" r="3" stroke="currentColor" strokeWidth="2" />
  </svg>
)

export default MessageNotificationSquare
